import React from "react";
import { Link } from "react-router-dom";
import { CTABanner } from "../components/CTABanner";
import { FadeInOnScroll } from "../components/FadeInOnScroll";

const services = [
  { icon: "🦷", title: "Stomatologie Generală", desc: "Consultații, obturații, extracții și igienizare profesională." },
  { icon: "🌟", title: "Albire Dentară", desc: "Sisteme profesionale de albire pentru un zâmbet strălucitor." },
  { icon: "🔧", title: "Implantologie", desc: "Implanturi dentare de înaltă calitate, soluția permanentă pentru dinții lipsă." },
  { icon: "😁", title: "Ortodonție", desc: "Aparate dentare fixe și invizibile pentru un zâmbet perfect aliniat." },
  { icon: "👑", title: "Proteză Dentară", desc: "Proteze fixe și mobile realizate cu materiale premium." },
  { icon: "🧒", title: "Stomatologie Pediatrică", desc: "Îngrijire specializată și blândă pentru cei mici." },
];

const testimonials = [
  { text: "M-am temut mereu de dentist, dar la DentaPro totul a fost calm și nedureros. Recomand cu toată inima!", author: "Maria T., Timișoara" },
  { text: "Tratament de implant realizat profesionist, în cel mai scurt timp. Rezultatul este spectaculos!", author: "Bogdan R., Timișoara" },
  { text: "Copilul meu merge acum cu drag la dentist! Echipa este extraordinar de răbdătoare cu cei mici.", author: "Ioana M., Lugoj" },
];

const trust = [
  { icon: "✅", text: "+5.000 Pacienți Mulțumiți" },
  { icon: "🏆", text: "10 Ani de Experiență" },
  { icon: "🦷", text: "Tehnologie de Ultimă Generație" },
  { icon: "🕐", text: "Program Flexibil Luni–Sâmbătă" },
];

export default function Home() {
  return (
    <div data-testid="page-home">
      {/* HERO */}
      <section className="hero" data-testid="hero-section">
        <div className="container-main">
          <div className="hero-grid">
            <div>
              <span className="pill-label" data-testid="hero-pill">Clinică Stomatologică Timișoara</span>
              <h1 className="hero-title" data-testid="hero-title">Zâmbetul Tău, Prioritatea Noastră</h1>
              <p className="hero-text">
                La DentaPro Clinic îți oferim îngrijire dentară completă, într-un mediu modern,
                steril și primitor. Programează-te astăzi și fă primul pas către un zâmbet sănătos.
              </p>
              <div className="hero-buttons">
                <Link to="/contact" className="btn btn-primary" data-testid="hero-call-btn">
                  📞 Sună Acum
                </Link>
                <Link to="/servicii" className="btn btn-outline" data-testid="hero-services-btn">
                  Vezi Serviciile
                </Link>
              </div>
            </div>
            <div className="hero-illustration" data-testid="hero-illustration">
              <img
                src="https://images.unsplash.com/photo-1606811971618-4486d14f3f99?auto=format&fit=crop&w=1000&q=80"
                alt="Pacient la cabinet dentar DentaPro Clinic"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BADGES */}
      <div className="trust-strip">
        <div className="container-main">
          <div className="trust-grid" data-testid="trust-grid">
            {trust.map((t, i) => (
              <div key={i} className="trust-item">
                <div className="trust-icon">{t.icon}</div>
                <div className="trust-text">{t.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ABOUT */}
      <section className="section-white" data-testid="about-section">
        <div className="container-main">
          <div className="about-grid">
            <FadeInOnScroll>
              <div className="about-image">
                <img
                  src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1000&q=80"
                  alt="Cabinetul DentaPro Clinic Timișoara"
                  loading="lazy"
                />
              </div>
            </FadeInOnScroll>
            <FadeInOnScroll delay={150}>
              <div className="about-text">
                <span className="pill-label">Despre Noi</span>
                <h2>De Ce Să Alegi DentaPro Clinic?</h2>
                <p>
                  DentaPro Clinic este o clinică stomatologică modernă din Timișoara, fondată în
                  2014 cu misiunea de a oferi tratamente dentare de calitate superioară într-un
                  mediu sigur și confortabil.
                </p>
                <p>
                  Echipa noastră de medici specialiști utilizează tehnologii avansate — de la
                  radiografii digitale la tehnici minim-invazive — pentru a asigura tratamente
                  eficiente și nedureroase.
                </p>
                <p>
                  Credem că fiecare pacient merită îngrijire personalizată. De aceea, luăm timp
                  să ascultăm nevoile tale și să îți oferim cel mai potrivit plan de tratament.
                </p>
                <div className="stats-row">
                  <div className="stat-box">
                    <div className="stat-box-num">10+</div>
                    <div className="stat-box-label">Ani experiență</div>
                  </div>
                  <div className="stat-box">
                    <div className="stat-box-num">12</div>
                    <div className="stat-box-label">Medici specialiști</div>
                  </div>
                  <div className="stat-box">
                    <div className="stat-box-num">98%</div>
                    <div className="stat-box-label">Pacienți satisfăcuți</div>
                  </div>
                </div>
              </div>
            </FadeInOnScroll>
          </div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="section-gray" data-testid="services-preview">
        <div className="container-main">
          <div className="center-text">
            <span className="pill-label">Servicii</span>
            <h2 className="section-title" style={{ marginTop: 14 }}>Serviciile Noastre</h2>
            <p className="section-subtitle">Tratamente complete pentru toată familia</p>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <FadeInOnScroll key={i} delay={i * 80}>
                <div className="service-card" data-testid={`service-card-${i}`}>
                  <div className="service-icon">{s.icon}</div>
                  <h3>{s.title}</h3>
                  <p>{s.desc}</p>
                  <Link to="/servicii" className="service-link">Află mai mult →</Link>
                </div>
              </FadeInOnScroll>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section-white" data-testid="testimonials-section">
        <div className="container-main">
          <div className="center-text">
            <span className="pill-label">Recenzii</span>
            <h2 className="section-title" style={{ marginTop: 14 }}>Ce Spun Pacienții Noștri</h2>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((t, i) => (
              <FadeInOnScroll key={i} delay={i * 100}>
                <div className="testimonial">
                  <div className="quote-mark">&ldquo;</div>
                  <p className="testimonial-text">{t.text}</p>
                  <div className="testimonial-stars">★ ★ ★ ★ ★</div>
                  <div className="testimonial-author">— {t.author}</div>
                </div>
              </FadeInOnScroll>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
